"use client";
import React from 'react';
import { ReportFilterType } from '../types';
import { MetricLocalizationsFilter, VehicleCategoriesFilter, VehiclesWarningsFilter } from '@/components';

type Props = {
  filters: ReportFilterType,
  setFilters: React.Dispatch<React.SetStateAction<ReportFilterType>>,
}

const VehicleMPArgumentsContariner = ({filters, setFilters}: Props) => {
  return (
    <>
        <div className="rm-relative md:rm-col-span-6 lg:rm-col-span-4 xl:rm-col-span-3">  
          <MetricLocalizationsFilter
            value={filters.vehicleRecordsRequest.metricPointsUIds}
            handleChange={(e) => setFilters({
            ...filters, 
            vehicleRecordsRequest: { 
                ...filters.vehicleRecordsRequest, 
                metricPointsUIds: e.target.value 
            }
            })} 
          />
        </div>
        <div className="rm-relative md:rm-col-span-6 lg:rm-col-span-4 xl:rm-col-span-3">  
          <VehiclesWarningsFilter
            value={filters.vehiclesWarnings}
            handleChange={(value) => setFilters({
            ...filters, 
            vehiclesWarnings: value
            })} 
          />
        </div>
        <div className="rm-relative md:rm-col-span-6 lg:rm-col-span-4 xl:rm-col-span-3">  
          <VehicleCategoriesFilter
            value={filters.categories}
            handleChange={(e) => setFilters({
            ...filters, 
            categories: e.target.value
            })} 
          />
        </div>
    </>
  );
};

export default VehicleMPArgumentsContariner;